import { useTranslations } from '@vocab/react';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTypedSelector } from 'src/reducers';

import { useSetCandidateId } from '../hooks/useSetCandidateId';
import { useUserProfile } from '../hooks/useUserProfile';
import PageLoader from '../page-loader';
import { PageTitles } from '../pageTitle';
import { useRoutes } from '../routes';
import { useSetTrackingContext } from '../tracking/tealium';

import translations from './.vocab';
import UnsubscribeJobAlert from './jobalert';
import UnsubscribeCTP from './unsubscribe-ctp';

const UnsubscribeContainer = () => {
  const { authenticationStatus } = useUserProfile();

  useSetCandidateId();

  useSetTrackingContext();

  const [token, setToken] = useState<string>('');
  const [product, setProduct] = useState<string>('');
  const [action, setAction] = useState<string | undefined>(undefined);

  const navigate = useNavigate();
  const { preferenceCentrePath } = useRoutes();
  const location = useLocation();
  const brand = useTypedSelector((store) => store.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramToken = params.get('token');
    const paramProduct = params.get('product');
    const paramAction = params.get('action');

    if (paramToken) {
      setToken(paramToken);
    } else {
      navigate(preferenceCentrePath);
    }

    setProduct(paramProduct || '');
    if (paramAction) {
      setAction(paramAction);
    }
  }, [navigate, location.search, preferenceCentrePath]);

  const getUnsubscribeContent = () => {
    if (product?.toLocaleLowerCase() === 'jobalert') {
      return (
        <UnsubscribeJobAlert
          token={token}
          authenticationStatus={authenticationStatus}
          action={action}
        />
      );
    }

    return <UnsubscribeCTP token={token} />;
  };

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('unsubscribe-page-title')}`}</title>
      </Helmet>
      {token ? getUnsubscribeContent() : <PageLoader />}
    </>
  );
};

export default UnsubscribeContainer;
